import AbstractConfig from "../../../core/config/AbstractConfig";
import DashboardConfig from "./DashboardConfig";

export default class DashboardData extends AbstractConfig {
    /**
     * 
     * @param {DashboardConfig} dashboardConfig 
     */
    constructor(dashboardConfig) {
        super();
        this._savedDashboardData = null;
        this._dashboardConfig = dashboardConfig;
    }

    getSaveConfig() {
        if (this._savedDashboardData == null) {
            this._savedDashboardData = this.getValue('dashboard-data');
            return this._savedDashboardData;
        } else {
            return this._savedDashboardData;
        }
    }

    getEpiData() {
        const dashboardData = this.getSaveConfig();
        return dashboardData[DashboardData.NODE_EPIDATA];
    }

    getHealthSystems() {
        const dashboardData = this.getSaveConfig();
        return dashboardData[DashboardData.NODE_HEALTHSYSTEMS];
    }

    getDashboardDataUntil(dataType, aimedChapter, aimedWeek, aimedPath) {
        aimedPath = (!aimedPath || aimedPath == null ? "" : aimedPath);
        const dashboardData = this.getSaveConfig();
        const data = dashboardData[dataType];
        return data.filter(node => {
            return node[DashboardData.COL_WEEK] <= aimedWeek &&
                node[DashboardData.COL_CHAPTER] <= aimedChapter &&
                aimedPath.toLowerCase().startsWith(node[DashboardData.COL_PATH].replace('_', '').toLowerCase());
        });
    }

    getCurrentDashboardData(dataType, chapter, week, path) {
        let dataSet = this.getDashboardDataUntil(dataType, chapter, week, path);
        if (dataSet != null && dataSet.length > 0) {
            return dataSet.slice(-1)[0];
        }
        return null;
    }

    getPreviousDashboardData(dataType, chapter, week, path) {
        let dataSet = this.getDashboardDataUntil(dataType, chapter, week, path);
        if (dataSet != null && dataSet.length > 1) {
            return dataSet.slice(-2)[0];
        }
        return null;
    }

    getMin(dataType, column) {
        const dashboardData = this.getSaveConfig();
        const node = dashboardData[dataType];
        if (node.length === 0) return undefined;

        let minValue = node[0][column];

        for (let i = 1; i < node.length; i++) {
            const currentValue = node[i][column];

            if (currentValue < minValue) {
                minValue = currentValue;
            }
        }

        return minValue;
    }

    getMax(dataType, column) {
        const dashboardData = this.getSaveConfig();
        const node = dashboardData[dataType];
        if (node.length === 0) return undefined;

        let maxValue = node[0][column];

        for (let i = 1; i < node.length; i++) {
            const currentValue = node[i][column];

            if (currentValue > maxValue) {
                maxValue = currentValue;
            }
        }

        return maxValue;
    }

    getCurrentRcceMovieClipId(weekNumber) {
        let movieClipId;
        while(weekNumber > 0 && !(movieClipId = this._dashboardConfig.getRCCEMovieClipPerWeek(weekNumber))) {
            weekNumber--;
        }
        return movieClipId;
    }

    hasNewRcceData(weekNumber) {
        return !!this._dashboardConfig.getRCCEMovieClipPerWeek(weekNumber);
    }

    getCurrentEpiData(chapter, week, path) {
        return this.getCurrentDashboardData(DashboardData.NODE_EPIDATA, chapter, week, path);
    }

    getCurrentHealthSystems(chapter, week, path) {
        return this.getCurrentDashboardData(DashboardData.NODE_HEALTHSYSTEMS, chapter, week, path);
    }

    getPreviousEpiData(chapter, week, path) {
        return this.getPreviousDashboardData(DashboardData.NODE_EPIDATA, chapter, week, path);
    }

    getPreviousHealthSystems(chapter, week, path) {
        return this.getPreviousDashboardData(DashboardData.NODE_HEALTHSYSTEMS, chapter, week, path);
    }

    getCumulativeData(dataType, path) {
        const dashboardData = this.getSaveConfig();
        return dashboardData.epilogue[dataType].path[path.toUpperCase()];
    }

    getBestCumulativeData(dataType) {
        const dashboardData = this.getSaveConfig();
        return dashboardData.epilogue[dataType].best;
    }

    getWorstCumulativeData(dataType) {
        const dashboardData = this.getSaveConfig();
        return dashboardData.epilogue[dataType].worst;
    }

    hasNewEpiData(chapter, week, path) {
        return this._hasNewDataForType(DashboardData.NODE_EPIDATA, chapter, week, path);
    }

    hasNewHealthSystemsData(chapter, week, path) {
        return this._hasNewDataForType(DashboardData.NODE_HEALTHSYSTEMS, chapter, week, path);
    }

    _hasNewDataForType(dataType, chapter, week, path) {
        path ??= "";
        const dashboardData = this.getSaveConfig();
        /** @type {object[]} */
        const data = dashboardData[dataType];
        const node = data.find(node => node[DashboardData.COL_WEEK] === week
            && node[DashboardData.COL_CHAPTER] === chapter
            && node[DashboardData.COL_PATH].replace('_', '').toLowerCase() === path.toLowerCase());
        return !!node;
    }
}
DashboardData.NODE_EPIDATA = "dashboard-epidata";
DashboardData.NODE_HEALTHSYSTEMS = "dashboard-health-systems";
DashboardData.NODE_CUMULATIVE_CASES = "cumulative-cases";
DashboardData.NODE_CUMULATIVE_DEATHS = "cumulative-deaths";
DashboardData.NODE_CUMULATIVE_NON_ENVD = "cumulative-non-envd";
DashboardData.COL_CHAPTER = "Chapter";
DashboardData.COL_WEEK = "Sim week";
DashboardData.COL_PATH = "Path";
DashboardData.COL_NBR_SUSPECTED_CASES = "Number of Suspected Cases";
DashboardData.COL_NBR_CONFIRMED_CASES = "Number of Confirmed Cases";
DashboardData.COL_NBR_SUSPECTED_DEATHS = "Suspected Deaths";
DashboardData.COL_NBR_CONFIRMED_DEATHS = "Confirmed Deaths";




